import axios from 'axios';
import { BASE_URL } from '../utils/ip';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle both 401 (Unauthorized) and 403 (Forbidden) for token refresh
    // Skip refresh for permanent access denials (customer blocked) and auth endpoints
    const isAccessDenied = error.response?.data?.code === 'CUSTOMER_ACCESS_DENIED';
    const isAuthEndpoint = originalRequest.url?.includes('/auth/login') ||
                           originalRequest.url?.includes('/auth/refresh');

    if ((error.response?.status === 401 || error.response?.status === 403) &&
        !originalRequest._retry &&
        !isAccessDenied &&
        !isAuthEndpoint) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const { data } = await axios.post(
          `${BASE_URL}/auth/refresh`,
          { refreshToken },
          { withCredentials: true }
        );

        localStorage.setItem('accessToken', data.data.accessToken);
        originalRequest.headers.Authorization = `Bearer ${data.data.accessToken}`;
        
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Clear all auth data and redirect to login
        localStorage.clear();
        // Trigger session expired modal if available
        window.dispatchEvent(new CustomEvent('sessionExpired'));
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;